import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import ListingComponent from "..//ListingComponent";
import ListingCell from "./listingViewCell";
import CheckBox from '../Checkbox';
import {
    updatePagingModel as workkardUpdatePagingModel,
    fetchWorkkardListingDataRequest as getWorkkardListingData,
} from "../../containers/WorkkardListing/slice";
import {
    updatePagingModel as activityUpdatePagingMOdel,
    fetchActivityListingDataRequest as getActivityListingData,
    activityListingBulkActionCancel as activityGridBulkActionCancel,
    activityListingBulkActionConfirm as activityGridBulkActionConfirm,
} from "../../containers/ActivityListing/slice";
import ConfirmationTextBox from "../ConfirmationPrompt";
import { showDialogueBox, hideDialogueBox } from '../DialogueBox/actions';
import { ListingViewConstants } from '../../common/constants';
import { showToast, hideToast } from '../../containers/SpockViewPage/actions/action';
import { TOOLTIP_DELAY_TIME } from '../../containers/SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../Tooltip/constants';
import UserMiniProfile from "../../components/UserMiniProfile";
import { useModules } from '../../utils/modules';

const ListingView = (props) => {
    const { isModuleEnabled } = useModules();
    const dispatch = useDispatch();
    const bulkAction = useSelector(state => state.activityListing.bulkAction);
    const toast = useSelector(state => state.toast);

    const toastPayload = React.useRef({
        message: "Select activities to Accept or Reject",
        type: "success",
        delayTime: 5000,
        showActions: false,
        isCloseIcon: true,
        autoClose: false
    });

    const handleCheckboxChange = (evt, isAllSelected, id) => {
        let isChecked = !evt.checked;
        props.handleCheckboxChange(isChecked, isAllSelected, id);
    };

    const activityGridBulkActionConfirmFn = (type) => {
        dispatch(activityGridBulkActionConfirm({ ids: JSON.stringify(props.selectedids), type }));
    };
    React.useEffect(() => {
        if (!props.selectedids.length && props.selectedTab == "unassigned" && props.type === ListingViewConstants.Activity && !toast.show && props.data.menuList && props.data.menuList.length > 0) {
            dispatch(showToast(toastPayload.current));
        }
    }, [props.selectedTab]);

    React.useEffect(() => {
        if (props.selectedTab != "unassigned" && props.type === ListingViewConstants.Activity && toast.show) {
            dispatch(hideToast());
        }
    }, [props.selectedTab, toast.show]);

    React.useEffect(() => {
        if (bulkAction.showConfirmationBox) {
            const total = bulkAction.Data.TotalCount;
            const valid = bulkAction.Data.ValidCount;
            const keyData = {
                'AcceptActivity': { url: "blkaccact", popUpHeader: `Accept Activit${total > 1 ? 'ies' : 'y'}`, messageText: "accept", messagePastText: "accepted" },
                'RejectActivity': { url: "blkrejact", popUpHeader: `Reject Activit${total > 1 ? 'ies' : 'y'}`, messageText: "reject", messagePastText: "rejected" },
                'AcceptAndReassignActivity': { url: "blkaccreaasact", popUpHeader: `Accept & Reassign Activit${total > 1 ? 'ies' : 'y'}`, messageText: "accept & reassign", messagePastText: "accepted & reassigned" }
            };
            const message = {
                "partial": `<p class="red">*${total - valid} of ${total} activities selected cannot be ${keyData[bulkAction.type].messagePastText}.</p> Are you sure you want to ${keyData[bulkAction.type].messageText} ${valid} activit${valid > 1 ? 'ies' : 'y'}?`,
                "none": `None of the activit${total > 1 ? 'ies' : 'y'} selected can be ${keyData[bulkAction.type].messagePastText}.`,
                "full": `Are you sure you want to ${keyData[bulkAction.type].messageText} ${total} activit${total > 1 ? 'ies' : 'y'}?`
            };
            let str = '';
            let hideButton = false;
            const header = keyData[bulkAction.type].popUpHeader;
            if (valid < total && valid != 0) {
                str = message["partial"];
            } else if (valid == total && valid != 0) {
                str = message["full"];
            } else {
                str = message["none"];
                hideButton = true;
            }
            dispatch(showDialogueBox({
                flag: true,
                component: <ConfirmationTextBox
                    class={"modalBody"}
                    message={str}
                    header={header}
                    onConfirmClick={() => {
                        if (!hideButton) {
                            activityGridBulkActionConfirmFn(bulkAction.type);
                            dispatch(hideDialogueBox());
                        } else {
                            dispatch(activityGridBulkActionCancel());
                            dispatch(hideDialogueBox());
                        }
                    }}
                    onCancelClick={() => { dispatch(activityGridBulkActionCancel()); dispatch(hideDialogueBox()); }}
                    confirmationText={hideButton ? "Okay" : "Confirm"}
                    footerClass={"modalFooter"}
                    cancelText={!hideButton ? "Cancel" : ""}
                    hideCancel={!hideButton}
                    messageTextClass="colFlex"
                />,
                overlayClassName: "modal",
                contentClassName: "modalContent small animated faster fadeInUpx2",
                shouldCloseOnOverlayClick: true
            }));
        }
    }, [bulkAction.showConfirmationBox]);

    React.useEffect(() => {
        return () => { dispatch(hideToast()); };
    }, []);

    const renderListing = () => {
        const { data, pagingModel, type, selectedTab, selectedids } = props;
        const prop = {
            data: data.WorkkardsFullData || data.ActivitiesFullData,
            cellTemplate: ListingCell,
            onScrollHandler: undefined,
            onItemClick: (pageNumber) => {
                if (type === ListingViewConstants.Workkard) {
                    dispatch(workkardUpdatePagingModel({
                        page: pageNumber.Page,
                        totalCount: pagingModel.totalCount,
                        rows: pagingModel.rows,
                    }));
                } else {
                    dispatch(activityUpdatePagingMOdel(pageNumber));
                }
                const { skip, take } = data;
                const payload = {
                    key: '',
                    skip: (skip === 0 && take > 10) ? take : parseInt(skip) + parseInt(take),
                    take: (skip === 0 && take > 10) ? 100 : parseInt(take),
                    rows: (skip === 0 && take > 10) ? take : parseInt(skip) + parseInt(take),
                    page: pageNumber.Page,
                    status: data.status,
                    isSearch: false,
                    sortDir: data.sortDir,
                    sortBy: data.sortBy,
                };
                if (type === ListingViewConstants.Workkard) {
                    dispatch(getWorkkardListingData({
                        ...payload,
                        view: ListingViewConstants.ListView,
                        isScroll: false,
                    }));
                } else {
                    dispatch(getActivityListingData(payload));
                }
            },
            onCellClick: (payload) => {
                const { target, userId, type, position, propertylocation , extraData } = payload;
                if (userId) {
                    dispatch({
                        type: SHOW_TOOLTIP,
                        payload: {
                            delay: TOOLTIP_DELAY_TIME,
                            target,
                            position,
                            childComponent: <UserMiniProfile userId={userId} type={type} wklocation={propertylocation} extraInfo={extraData}/>,
                        }
                    });
                }
            },
            type: "div",
            selectedId: '',
            classname: 'scrollArea',
            isPagination: true,
            extraData: {
                pagingModel, selectedTab, handleCheckboxChange,
                listType: type, selectedids, showCheckbox: data.menuList && data.menuList.length > 0, showCarrierClaim: false
            }
        };
        return (
            <React.Fragment>
                <ListingComponent {...prop} />
            </React.Fragment>
        );
    };

    const { data, type, selectedTab } = props;
    return (
        <div className="table cardListView scrollArea">
            <div className="rowFlex tableHead">
                <ul>
                    {type === ListingViewConstants.Activity && selectedTab === "unassigned" ?
                        <li className="rowFlex">
                            {data.menuList && data.menuList.length > 0 && <CheckBox item={{ id: "chkBoxAll", checked: props.isAllSelected }} handleCheckbox={(event) => handleCheckboxChange(event, true, 0)} />}
                            <div className="colFlex">{type.toLowerCase() === "workkard" ? 'Workkard Number' : 'Activity Info'}</div>
                        </li> :
                        <li className="">{type.toLowerCase() === "workkard" ? 'Workkard Number' : 'Activity Info'}</li>
                    }
                    <li className="">Workkard Info</li>
                    <li className="">{type.toLowerCase() === "workkard" ? 'Description' : 'Resolution'}</li>
                    <li className="">{type.toLowerCase() === "workkard" ? 'Workkard Owner' : 'Activity Owner'}</li>
                    {!(type.toLowerCase() === "workkard" && !isModuleEnabled("workkards.listing.carrier")) &&
                        <li className="">{type.toLowerCase() === "workkard" ? 'Carrier' : 'Activity Assignee'}</li>
                    }
                </ul>
            </div>
            <div className="rowFlex tableBody">
                <div>
                    {renderListing()}
                </div>
            </div>
        </div>
    );
};

export default ListingView;